import {Formio} from "formiojs";

const TextArea = Formio.Components.components.textarea;

export default class CustomTextArea extends TextArea {
    static schema(...extend) {
        return TextArea.schema({
            type: 'textEditor',
            label: 'Text Editor',
            key: 'textEditor',
            rows: 3,
            editor: 'quill',
            wysiwyg: false,
            fixedSize: true,
            inputFormat: 'html',
            validate: {
                minWords: '',
                maxWords: ''
            }
        }, ...extend);
    }

    static get builderInfo() {
        return {
            title: 'Text Editor',
            group: 'basic',
            icon: 'font',
            documentation: '/userguide/#textarea',
            weight: 20,
            schema: CustomTextArea.schema()
        };
    }

    renderElement(value, index) {
        const info = this.inputInfo;
        info.attr = info.attr || {};
        info.content = value;

        if (!this.options.readOnly || !this.disabled) {
            this.component.editor = 'quill';


        }

        if (this.options.readOnly || this.disabled) {

            // this.component.wysiwyg = {
            //     "modules": {
            //         "toolbar": false
            //     }
            // }
            this.component.wysiwyg = false;
            this.component.editor = false;


            return this.renderTemplate('well', {
                children: '<div ref="input" class="formio-editor-read-only-content"></div>',
                nestedKey: this.key,
                value
            });
        }

        return this.renderTemplate('input', {
            prefix: this.prefix,
            suffix: this.suffix,
            input: info,
            value,
            index
        });
    }
}
